import {InjectionToken} from "@angular/core";
import {StoragePort} from '@platform/storage/domain/ports/storage.port';
import {OrderState} from "@features/sales/application/store/order/order.store";

export const ORDER_STORE_STORAGE = new InjectionToken<StoragePort<OrderState>>('ORDER_STORE_STORAGE');
